import { FORECASTING_THEME } from './forecastingTheme';
import { DRILL_HEADER_BTN_CSS } from './components/DrillHeader';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const FORECASTING_TABLE_CSS = `
  .forecasting-bp-table .ant-table {
    background: transparent;
    color: ${FORECASTING_THEME.dataText};
  }
  .forecasting-bp-table .ant-table-container,
  .forecasting-bp-table .ant-table-content,
  .forecasting-bp-table .ant-table-body,
  .forecasting-bp-table .ant-table-header {
    background: transparent !important;
  }
  .forecasting-bp-table .ant-table-thead > tr > th {
    background: rgba(196, 181, 253, 0.15) !important;
    color: ${FORECASTING_THEME.dataText} !important;
    border-bottom: 1px solid rgba(${APP_SHELL_THEME.overlayRgb}, 0.1) !important;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }
  .forecasting-bp-table .ant-table-thead > tr > th.forecasting-drill-header-cell {
    text-align: left !important;
  }
  .forecasting-bp-table .ant-table-thead > tr > th.forecasting-drill-header-cell .ant-table-column-sorters {
    justify-content: flex-start;
  }
  .forecasting-bp-table .ant-table-tbody > tr > td {
    background: transparent !important;
    border-bottom: 1px solid rgba(${APP_SHELL_THEME.overlayRgb}, 0.06) !important;
    color: ${FORECASTING_THEME.dataText};
    font-size: 12px;
    /* Regular, not the app's Lato Light: thin strokes at 12px read as grey. */
    font-weight: 400;
  }
  .forecasting-bp-table .ant-table-tbody > tr > td.ant-table-column-sort {
    background: transparent !important;
  }
  .forecasting-bp-table .ant-table-tbody > tr:hover > td {
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.04) !important;
  }
  .forecasting-bp-table .ant-table-tbody > tr:hover > td.ant-table-column-sort {
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.04) !important;
  }
  .forecasting-bp-table .ant-table-tbody > tr.forecasting-row-selected > td {
    background: rgba(91, 141, 239, 0.15) !important;
  }
  .forecasting-bp-table .ant-table-summary,
  .forecasting-bp-table .ant-table-summary table {
    background: ${FORECASTING_THEME.panelBg} !important;
  }
  .forecasting-bp-table .ant-table-summary > tr > td,
  .forecasting-bp-table .ant-table-summary > tr > th,
  .forecasting-bp-table tfoot.ant-table-summary > tr > td,
  .forecasting-bp-table tfoot.ant-table-summary > tr > th {
    background: ${FORECASTING_THEME.panelBg} !important;
    background-color: ${FORECASTING_THEME.panelBg} !important;
    color: ${FORECASTING_THEME.text} !important;
    font-weight: 600;
    font-size: 12px;
    border-top: 1px solid rgba(${APP_SHELL_THEME.overlayRgb}, 0.12) !important;
    border-bottom: none !important;
  }
  .forecasting-bp-table .ant-table-summary .ant-table-cell {
    background: ${FORECASTING_THEME.panelBg} !important;
    background-color: ${FORECASTING_THEME.panelBg} !important;
  }
  .forecasting-bp-table .ant-table-summary .ant-table-cell-fix-left,
  .forecasting-bp-table .ant-table-summary .ant-table-cell-fix-right {
    background: ${FORECASTING_THEME.panelBg} !important;
    background-color: ${FORECASTING_THEME.panelBg} !important;
  }
  .forecasting-bp-table .ant-table-summary .ant-table-cell-fix-left::before,
  .forecasting-bp-table .ant-table-summary .ant-table-cell-fix-right::before {
    background: ${FORECASTING_THEME.panelBg} !important;
  }
  .forecasting-bp-table .ant-table-summary .ant-table-cell-scrollbar {
    background: ${FORECASTING_THEME.panelBg} !important;
    box-shadow: none !important;
  }
  .forecasting-bp-table .ant-pagination {
    color: ${FORECASTING_THEME.textMuted};
  }
  ${DRILL_HEADER_BTN_CSS}
  .forecasting-currency-cell {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  /* A row clicked into the page filters. */
  .forecasting-bp-table .forecasting-row-picked > td {
    background: rgba(${APP_SHELL_THEME.overlayRgb}, 0.08) !important;
    font-weight: 600;
  }
`;
